// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c2DeL5SxLMfcxziZlnoR{align-items:center;margin-right:auto;padding:12px 24px 12px 12px;display:flex}.c2DeL5SxLMfcxziZlnoR div.t3JPsdd9acMnzUpxNIWI{background:var(--action-contained-secondary-normal);border-radius:6px;justify-content:center;align-items:center;height:24px;font-size:12px;font-weight:500;display:flex}.c2DeL5SxLMfcxziZlnoR div.t3JPsdd9acMnzUpxNIWI:hover{background:var(--action-contained-secondary-hovered)}.c2DeL5SxLMfcxziZlnoR .DTxPF8myp7of7_13bApQ{color:var(--content-primary-tertiary);font-size:12px;font-weight:500}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `c2DeL5SxLMfcxziZlnoR`,
	"select": `t3JPsdd9acMnzUpxNIWI`,
	"allRowsCount": `DTxPF8myp7of7_13bApQ`
};
export default ___CSS_LOADER_EXPORT___;
